<template>
  <div>
		<v-row row class="mt-2 ml-3 ml-md-0 mr-0 px-0">
			<router-link v-if="researcher.department_id" :to="{name:'detail',params:{id:researcher.department_id}}" tag="p" class=" orange--text text-h6 mx-0 px-0">
				<a class=" orange--text">
					{{ $t("researcher.department") }}
					<span v-if="researcher.departmentName" v-html="researcher.departmentName[language]"></span>
				</a>
			</router-link>
		</v-row>
		<v-row v-if="researcher.supervisors && researcher.supervisors[0].id" row class="mt-1  ml-0 mr-0 px-0 mb-1 grey--text">
			<span class="pl-0 pr-1  orange--text ">Supervisor:</span> <span v-html="researcher.supervisors[0].title" class="pr-1"></span>
			<span v-html="researcher.supervisors[0].first_name" class="pr-1"></span>
			<span v-html="researcher.supervisors[0].last_name" class="pr-1"></span>
		</v-row>
		<app-researcher-interest  :interests="interests" :cv="cv" :homepage="homepage"></app-researcher-interest>
		<v-row v-if="researcher.university && researcher.university[0].name" row class="mt-2 ml-3 ml-md-0 mr-0 mb-2 px-0 grey--text">
			<span class="pl-0 pr-1  orange--text ">Funding: </span>
			<a v-if="researcher.university[0].url":href="researcher.university[0].url" class="grey--text">
				<span v-html="researcher.university[0].name"></span>
			</a>
			<span  v-else v-html="researcher.university[0].name"></span>
		</v-row>
		<v-row  v-if="xsOnly"  class="mx-0 px-0">
				<v-col cols="12" class="ml-2 px-0">
					<app-researcher-basics  :researcher="researcher"></app-researcher-basics>
				</v-col>
		</v-row>
  </div>
</template>
<script>
import researcherInterest from './ResearcherInterest.vue';
import researcherBasics from './ResearcherBasics.vue';
import {mapGetters} from 'vuex';
export default {
props:['researcher','interests','cv','homepage'],
metaInfo() {
  if(this.researcher.departmentName)
      return{
          meta:
          [
              { vmid: "description", name: "description", content: this.researcher.departmentName['en']},
          ],
      }
},
data(){
  return{
    xsOnly:false,
  }
},
created(){
  this.xsOnly = this.$vuetify.breakpoint.xsOnly;
},
computed: {
...mapGetters('header',{
    language:'language',
  }),
},
components:{
  'AppResearcherInterest':researcherInterest,
  'AppResearcherBasics':researcherBasics,
}
}
</script>
